<template>
  <div class="index-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">禾悦</div>
          <div class="title">追求卓越，努力超越</div>
          <div class="subtitle"></div>
          <div class="desc">
            通过互联网服务提升人类生活品质，使产品和服务像水和电一样源源不断融入人们的生活，为人们带来便捷和愉悦；
            <br/>
            关注不同地域、不同群体，并针对不同对象提供差异化的产品和服务；
            <br/>
            打造开放共赢平台，与合作伙伴共同营造健康的互联网生态环境。
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container">
        <div class="intro-con">
          <div class="title">产品与服务</div>
          <div class="content content-box box-shadow">
            <div class="box-con">
              <div class="box-item" @click="handleRoute('/product', {type: 'pay'})">
                <img class="box-image" src="../../assets/images/pay/logo.png"/>
                <div class="box-title">统一支付云平台</div>
                <div class="box-desc">
                  提供更加创新、便捷的支付场景，为患者解决付费难的问题，从而帮助医院改善患者的医疗服务，帮助医院合理“关闭”收费
                </div>
              </div>
            </div>
             <div class="box-con">
              <div class="box-item" @click="handleRoute('/product1', {type: 'dz'})">
                <img class="box-image" src="../../assets/images/pay/merit-3.png"/>
                <div class="box-title">统一对账云平台</div>
                <div class="box-desc">
                  提供HIS交易记录明细获取、渠道订单获取、统一对账服务、账单查询/导出、争议订单处理（核销）、账单统计查询等功能
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item" @click="handleRoute('/product2', {type: 'hqms'})">
                <img class="box-image" src="../../assets/images/hqms/logo.png"/>
                <div class="box-title">分诊排队叫号系统</div>
                <div class="box-desc">
                  通过分诊排队系统可以实现病人自觉排队看病，提高医院看病效率，维护医院秩序，加快医院信息化建设的目标
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item" @click="handleRoute('/product3', {type: 'hqms'})">
                <img class="box-image" src="../../assets/images/spmp/logo.png"/>
                <div class="box-title">智慧场所云管理平台</div>
                <div class="box-desc">
                  提供混合云环境资源的统一纳管,统一运营,统一运维服务，平台整体了宗教信息化管理的效率和服务水平，扩宽了自身的宣传渠道，减轻了自身的事务压力
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item" @click="handleRoute('/product4', {type: 'hqms'})">
                <img class="box-image" src="../../assets/images/iv/logo.png"/>
                <div class="box-title">智慧村社管理平台</div>
                <div class="box-desc">
                  提升村社基层治理水平，建立村社自治信用评价体系，为基层治理提供管理抓手；搭建公共服务模块，打通民情民生反馈通道，为群众提供便民服务；建立村务管理系统，减轻基层工作人员工作压力
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item" @click="handleRoute('/product5', {type: 'hqms'})">
                <img class="box-image" src="../../assets/images/mss/logo.png"/>
                <div class="box-title">医疗自助服务系统</div>
                <div class="box-desc">
                 通过与医院、银行以及第三方的各平台进行无缝对接，让自助机器更加智能、便捷、安全、高效，为人们提供诸如：发卡、挂号、缴费、充值、查询、打印等等功能
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">更丰富的场景对接</div>
          <div class="content content-icon">
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-ckjs.png"/>
                <div class="icon-title">窗口结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-zjjs.png"/>
                <div class="icon-title">诊间结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-zzj.png"/>
                <div class="icon-title">自助机结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-sljs.png"/>
                <div class="icon-title">刷脸结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-ydjs.png"/>
                <div class="icon-title">移动结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-hstjs.png"/>
                <div class="icon-title">护士台结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-fztjs.png"/>
                <div class="icon-title">分诊台结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-cpjs.png"/>
                <div class="icon-title">床旁结算</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-zntc.png"/>
                <div class="icon-title">智能停车</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-fydy.png"/>
                <div class="icon-title">复印打印</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-gpkl.png"/>
                <div class="icon-title">光盘刻录</div>
              </div>
            </div>
            <div class="icon-con">
              <div class="icon-item">
                <img class="icon-image" src="../../assets/images/scene/scene-sbjs.png"/>
                <div class="icon-title">医后、无感、商保结算</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="intro-container">-->
        <!--<div class="intro-con">-->
          <!--<div class="title">1000+用户的选择</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>

export default {
  name: 'index',
  methods: {
    handleRoute (path, params = {}) {
      this.$router.push({
        path,
        params
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .header-container {
    height: 80px;
    line-height: 80px;
    box-shadow: 0 2px 13px rgba(0,0,0,.05);
  }

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue